import React from "react";
import styles from "../Footer/Footer.module.css";
import { AiFillMail } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
function Footer() {
  return (
    <>
      <div className={styles.footer}>

        <div className={styles.links}>
          <a href="mailto:baarbarabottazzi@gmail.com">
            <AiFillMail />
          </a>
        </div>
        <div className={styles.links}>
          <a href="https://ar.linkedin.com/in/barbara-bottazzi">
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </>
  );
}

export default Footer;
